const zipLabelMap = {
  US: 'dynamic.zip',
  CA: 'dynamic.postal',
  GB: 'dynamic.postcode',
  IS: 'dynamic.postcode',
  DEFAULT: 'dynamic.zip'
};
export const getZipLabel = (country: string) => getValue<string>(country, zipLabelMap);

const zipPlaceholderMap = {
  US: 'dynamic.enter_your_zip',
  CA: 'dynamic.enter_your_postal',
  GB: 'dynamic.enter_your_postcode',
  DEFAULT: 'dynamic.enter_your_zip'
};
export const getZipPlaceholder = (country: string) =>
  getValue<string>(country, zipPlaceholderMap);

const stateLabelMap = {
  US: 'dynamic.state',
  CA: 'dynamic.province',
  GB: 'dynamic.region',
  JP: 'dynamic.prefecture',
  DEFAULT: null
};
export const getStateLabel = (country: string) =>
  getValue<string | null>(country, stateLabelMap);

const statePlaceholderMap = {
  US: 'dynamic.enter_your_state',
  CA: 'dynamic.enter_your_province',
  GB: 'dynamic.enter_your_region',
  JP: 'dynamic.enter_your_prefecture',
  DEFAULT: null
};
export const getStatePlaceholder = (country: string) =>
  getValue<string | null>(country, statePlaceholderMap);

const getValue = <T>(country: string, map: Record<string, T>) => {
  const uppercaseCountry = country?.toUpperCase();
  return map[uppercaseCountry] || map.DEFAULT;
};

export const getDynamicStateLabel = (
  state: string | undefined | null,
  country: string
) => {
  let countryKey = country;
  let stateLabel = getStateLabel(countryKey);
  if (state && !stateLabel) {
    countryKey = 'US';
    stateLabel = getStateLabel('US');
  }

  return { label: stateLabel, countryKey };
};

export const getDynamicStateData = (
  state: string | undefined | null,
  country: string
) => {
  const { label: stateLabel, countryKey } = getDynamicStateLabel(state, country);
  const placeholder = getStatePlaceholder(countryKey);

  return { label: stateLabel, placeholder };
};
